import { render, staticRenderFns } from "./SectionPaid.vue?vue&type=template&id=378e53d2&"
import script from "./SectionPaid.vue?vue&type=script&lang=js&"
export * from "./SectionPaid.vue?vue&type=script&lang=js&"
import style0 from "./SectionPaid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports